import React from "react";
import type {FunctionComponent} from "react";
import "./CheckboxListItem.scss";
import {useCheckboxListItemLogic} from "./CheckboxListItem.logic";
import {FontIcon, Icon} from "../FontIcon";

export interface ICheckboxProps {
  label: string;
  icon?: Icon;
  isChecked: boolean;
  isIndeterminate?: boolean;
  onClick?: () => void;
}

export const CheckboxListItem: FunctionComponent<ICheckboxProps> = ({label, icon, isChecked, isIndeterminate, onClick, children}) => {
  const {inputRef} = useCheckboxListItemLogic({isChecked, isIndeterminate});

  return <li className={`checkboxGroup`}>
    <label className={`checkboxInputAndLabel`}>
      <input type={"checkbox"} ref={inputRef} checked={isChecked} readOnly onClick={onClick ?? (() => {})} />
      {icon ? <FontIcon icon={icon}/> : null}
      <span className={`checkboxLabel`}>{label}</span>
    </label>
    {children}
  </li>;
}
